/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Precheck_Ignore_AllInputs */



/**
* | output |
* | --- |
* | "Ignore All" |
*
* @param {Subtitle_Export_Precheck_Ignore_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_precheck_ignore_all = /** @type {((inputs?: Subtitle_Export_Precheck_Ignore_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Precheck_Ignore_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ignorer tout")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle ignorieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ignora tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Игнорировать всё")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ignorar todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("忽略所有")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて無視")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी को अनदेखा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ignorar tudo")
	return /** @type {LocalizedString} */ ("Ignore All")
});